import React from 'react';
// import ReactDOM from 'react-dom';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { initServer } from './__mocks__/browser';
import { environment } from './environments/environment';

// Workaround for Google Translate compatibility issue with React
// See: https://github.com/facebook/react/issues/11538#issuecomment-417504600
/* eslint-disable @typescript-eslint/no-explicit-any, func-names */
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(child: T): T {
    if (child.parentNode !== this) {
      // eslint-disable-next-line no-console
      console.error('Cannot remove a child from a different parent', child, this);
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(
    newNode: T,
    referenceNode: Node | null,
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      // eslint-disable-next-line no-console
      console.error(
        'Cannot insert before a reference node from a different parent',
        referenceNode,
        this,
      );
      return newNode;
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };
}
/* eslint-enable @typescript-eslint/no-explicit-any, func-names */

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

async function bootstrapApp() {
  if (environment?.useMockServer) {
    await initServer();
  }
  root.render(
    <App />,
  );
}
bootstrapApp();

// const AppWrapper = () => (
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// ReactDOM.render(
//   <AppWrapper />,
//   document.getElementById('root'),
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
